// src/pages/Home.js
import "./Home.css";
import { Link } from 'react-router-dom';
import { useEffect, useMemo, useState } from 'react';
import { apiFetch } from '../api';
import logo from "../assets/logo.png"; // 确认路径

const Icon = ({ name }) => {
  const base = {
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };
  switch (name) {
    case 'xhs':
      return (
        <svg {...base} aria-hidden="true">
          <path d="M12 3l2.4 4.7 5.2.8-3.8 3.7.9 5.3L12 14.9 7.3 17.5l.9-5.3-3.8-3.7 5.2-.8L12 3z" />
        </svg>
      );
    case 'pengyouquan':
      return (
        <svg {...base} aria-hidden="true">
          <path d="M4 5.5h10a2 2 0 0 1 2 2V12a2 2 0 0 1-2 2H9l-3.5 3V14H4a2 2 0 0 1-2-2V7.5a2 2 0 0 1 2-2z" />
          <path d="M12 7.5h6a2 2 0 0 1 2 2V14a2 2 0 0 1-2 2h-2l-2.5 2V16" />
        </svg>
      );
    case 'douyin':
      return (
        <svg {...base} aria-hidden="true">
          <path d="M5 18V9" />
          <path d="M10 18V6" />
          <path d="M15 18V12" />
          <path d="M18 7l3 2-3 2z" />
        </svg>
      );
    case 'coze':
      return (
        <svg {...base} aria-hidden="true">
          <path d="M4 12h4l2-4 3 8 2-4h5" />
          <circle cx="12" cy="12" r="9" />
        </svg>
      );
    case 'topic':
      return (
        <svg {...base} aria-hidden="true">
          <circle cx="12" cy="12" r="8" />
          <path d="M12 4v4l4 4" />
          <circle cx="16" cy="8" r="1.5" />
        </svg>
      );
    case 'title':
      return (
        <svg {...base} aria-hidden="true">
          <path d="M4 20l4-1 10-10-3-3L5 16l-1 4z" />
          <path d="M13 6l3 3" />
        </svg>
      );
    case 'copy':
      return (
        <svg {...base} aria-hidden="true">
          <path d="M7 7h9a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9l-4 3v-3H7a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2z" />
          <path d="M10 4h7a2 2 0 0 1 2 2v2" />
        </svg>
      );
    case 'kb':
      return (
        <svg {...base} aria-hidden="true">
          <ellipse cx="12" cy="6" rx="6.5" ry="2.5" />
          <path d="M5.5 6v4c0 1.4 2.9 2.5 6.5 2.5s6.5-1.1 6.5-2.5V6" />
          <path d="M5.5 10v4c0 1.4 2.9 2.5 6.5 2.5s6.5-1.1 6.5-2.5v-4" />
        </svg>
      );
    case 'flow':
      return (
        <svg {...base} aria-hidden="true">
          <circle cx="6" cy="6" r="2.2" />
          <circle cx="18" cy="6" r="2.2" />
          <circle cx="12" cy="18" r="2.2" />
          <path d="M8.2 6h7.6" />
          <path d="M7.4 7.6 10.6 15" />
          <path d="M16.6 7.6 13.4 15" />
        </svg>
      );
    case 'metrics':
      return (
        <svg {...base} aria-hidden="true">
          <path d="M4 18h16" />
          <path d="M6 16l4-5 4 3 4-6" />
          <circle cx="10" cy="11" r="1.3" />
          <circle cx="14" cy="14" r="1.3" />
          <circle cx="18" cy="8" r="1.3" />
        </svg>
      );
    case 'assets':
      return (
        <svg {...base} aria-hidden="true">
          <path d="M4 7a2 2 0 0 1 2-2h4l2 2h6a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V7z" />
          <path d="M4 10h16" />
        </svg>
      );
    default:
      return (
        <svg {...base} aria-hidden="true">
          <circle cx="12" cy="12" r="8" />
          <path d="M8 12h8" />
        </svg>
      );
  }
};

export default function Home() {
  const [balance, setBalance] = useState(null);
  const [loadingBal, setLoadingBal] = useState(false);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("all");
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const nickname = typeof window !== 'undefined' ? (localStorage.getItem('nickname') || '用户') : '用户';

  const fetchBalance = async () => {
    if (!token) { setBalance(null); return; }
    try {
      setLoadingBal(true);
      const r = await apiFetch('/api/auth/me');
      const b = (r?.user?.balance ?? r?.balance);
      const n = (typeof b === 'string') ? Number(b) : b;
      setBalance(Number.isFinite(n) ? n : null);
    } catch (e) {
      if (e?.status === 401) {
        localStorage.removeItem('token');
      }
      console.warn('fetch balance error:', e?.message || e);
    } finally {
      setLoadingBal(false);
    }
  };

  useEffect(() => { fetchBalance(); /* eslint-disable-next-line */ }, [token]);

  const items = useMemo(() => ([
    { id:'xhs', title:'提取小红书爆款内容', desc:'输入链接调用 API 并展示结果。', icon:'🍓', to:'/xhs-runner', cat:'analysis' },
    { id:'pengyouquan', title:'朋友圈文案写作', desc:'输入提示，AI 一键生成朋友圈文案。', icon:'💬', to:'/pengyouquan', cat:'writing' },
    { id:'douyin',  title:'网络大V首页分析', desc:'一键分析对标账户', icon:'📊', to:'/douyin-homepage', cat:'analysis' },
    { id:'coze',    title:'一键提取抖音爆款内容', desc:'输入链接调用 API 并展示结果。', icon:'🧭', to:'/coze-runner', cat:'analysis' },
    { id:'topic',   title:'行业热点追踪', desc:'搜索行业热点，商业启发，口播稿', icon:'🎯', to:'/topic-radar', cat:'creation' },
    { id:'title',   title:'金枪大叔智能体', desc:'爆款标题/文案生成，支持 A/B 模式输出。', icon:'🧨', to:'/jinqiangdashu', cat:'writing' },
    { id:'copy',    title:'开头3s钩子智能体', desc:'生成短视频/直播/笔记的3秒抓人开头与钩子句。', icon:'✍️', to:'/hook-3s', cat:'writing' },
    { id:'kb',      title:'成交文案智能体', desc:'输入产品/服务信息与目标人群，生成可落地的成交文案。', icon:'🧹', to:'/deal-copy-agent', cat:'automation' },
    { id:'flow',    title:'选题策划智能体', desc:'输入账号定位与商业目标，输出可执行的选题策划方案。', icon:'🧩', to:'/topic-planner', cat:'automation' },
    { id:'metrics', title:'神评论智能体', desc:'输入视频核心观点，生成高赞神评论。', icon:'📈', to:'/god-comment', cat:'analysis' },
    { id:'assets',  title:'王扬名成交型文案', desc:'输入产品/服务信息与成交目标，生成成交型文案。', icon:'🗂️', to:'/wym-copy', cat:'creation' },
  ]), []);

  const filtered = useMemo(() => {
    const kw = q.trim().toLowerCase();
    return items.filter(it => {
      if (cat !== 'all' && it.cat !== cat) return false;
      if (!kw) return true;
      return it.title.toLowerCase().includes(kw) || it.desc.toLowerCase().includes(kw);
    });
  }, [items, q, cat]);

  const Card = ({it}) => {
    const Kicker = it.cat === 'creation' ? '创作' : it.cat === 'analysis' ? '分析' : it.cat === 'automation' ? '自动化' : '写作';
    const Inner = () => (
      <>
        <span className="icon" aria-hidden="true"><Icon name={it.id} /></span>
        <span className="kicker">{Kicker}</span>
        <span className="name">{it.title}</span>
        <span className="desc">{it.desc}</span>
        <div className="card-actions">
          <span className="use-btn">立即使用</span>
        </div>
      </>
    );
    if (it.to) {
      return <Link className="tab" to={it.to}><Inner/></Link>;
    }
    return (
      <a className="tab" href={it.href} target={it.external ? "_blank" : undefined} rel={it.external ? "noopener noreferrer" : undefined}>
        <Inner/>
      </a>
    );
  };

  return (
    <div className="home-page">
      <header className="header">
        <div className="brand">
          <img src={logo} alt="logo" className="brand-logo" />
          <div className="brand-text">
            <div className="title">本源AI · 简单高效</div>
            <div className="subtitle">让小团队也能跑出大产能</div>
          </div>
        </div>
        <div className="userline">
          {token ? (
            <>
              <span>你好，{nickname}</span>
              <span className="badge">余额：{loadingBal ? '加载中…' : (balance == null ? '—' : `${balance} 积分`)}</span>
              <Link to="/recharge" className="btn primary" style={{textDecoration:'none'}}>充值</Link>
              <button className="btn" onClick={() => { localStorage.removeItem('token'); localStorage.removeItem('nickname'); window.location.reload(); }}>退出</button>
            </>
          ) : (
            <div style={{ display:'flex', gap:8 }}>
              <a className="btn link" href="/login">登录</a>
              <a className="btn link" href="/register">注册</a>
            </div>
          )}
        </div>
      </header>

      <main className="wrap">
        <section className="toolbar" aria-label="筛选与搜索">
          <div className="search">
            <span aria-hidden="true">🔎</span>
            <input value={q} onChange={e => setQ(e.target.value)} placeholder="搜索工具 / 智能体…" aria-label="搜索工具或智能体" />
          </div>
          <div className="chips" role="tablist" aria-label="类别筛选">
            {['all','creation','analysis','automation','writing'].map(k => (
              <button key={k} role="tab" aria-selected={cat === k} className={`chip ${cat === k ? 'active' : ''}`} onClick={() => setCat(k)}>
                {k === 'all' ? '全部' : k === 'creation' ? '创作' : k === 'analysis' ? '分析' : k === 'automation' ? '自动化' : '写作'}
              </button>
            ))}
          </div>
        </section>

        <section className="grid" role="navigation" aria-label="聚合入口">
          {filtered.map(it => <Card key={it.id} it={it} />)}
        </section>

        <footer className="footer">沪ICP备16037514号           · 本源AI   © {new Date().getFullYear()}  <code> v1.3</code></footer>
      </main>
    </div>
  );
}
